import React, { useState, useEffect } from 'react'

const CloudServices = () => {
    const [activeService, setActiveService] = useState('cloud-strategy');

    useEffect(() => {
        // Add click event listeners to service tabs
        const tabs = document.querySelectorAll('.service-tab');
        const details = document.querySelectorAll('.service-detail');

        tabs.forEach(tab => {
            tab.addEventListener('click', () => {
                const service = tab.getAttribute('data-service');

                // Remove active class from all tabs and details
                tabs.forEach(t => t.classList.remove('active'));
                details.forEach(d => d.classList.remove('active'));

                // Add active class to clicked tab and corresponding detail
                tab.classList.add('active');
                document.getElementById(service).classList.add('active');

                setActiveService(service);
            });
        });
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <section className="breadcrumb-hero">
                <div className="breadcrumb-overlay"></div>
                <div className="breadcrumb-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                {/* <div className="breadcrumb-tagline">
                                    <span className="breadcrumb-line"></span>
                                    <span className="breadcrumb-text">EMPOWER YOUR BUSINESS WITH THE CLOUD</span>
                                </div> */}
                                <h1 className="breadcrumb-title">
                                    Cloud <span className="breadcrumb-highlight">Services</span>
                                </h1>
                                <button className="breadcrumb-btn">
                                    <span>CONNECT NOW</span>
                                    <span className="breadcrumb-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="breadcrumb-pattern"></div>
            </section>

            {/* Cloud Services Overview Section */}
            <section className="ai-driven-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="ai-driven-content">
                                <h2 className="ai-driven-title" style={{ textAlign: 'left' }}>
                                    <span className="text-gradient">Enterprise Cloud Solutions </span> for Modern Businesses
                                </h2>
                                <p className="ai-driven-description">
                                    Transform your IT infrastructure with CLOUD MIND X's comprehensive cloud services. We help businesses migrate, optimize, and manage their cloud environments across AWS, Microsoft Azure, and Google Cloud Platform. Our expert cloud architects design scalable, secure, and cost-efficient solutions that drive innovation, enhance agility, and accelerate digital transformation across industries.
                                </p>
                                <button className="ai-driven-btn">
                                    <span>TALK TO A CLOUD EXPERT</span>
                                    <span className="ai-driven-arrow">
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="ai-driven-image-wrapper">
                                <img
                                    src="https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=800&q=80"
                                    alt="Cloud Services"
                                    className="ai-driven-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* How We Help Section */}
            <section className="how-we-help-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-header text-center mb-5">
                                <span className="section-tagline">OUR CLOUD EXPERTISE</span>
                                <h2 className="section-title" style={{ textAlign: 'center' }}>How We Help</h2>
                                <p className="text-muted lead m-0">
                                    With certified cloud architects and engineers specializing in multi-cloud environments,<br />
                                    <span className="text-gradient">CLOUD MIND X</span> delivers end-to-end cloud solutions that optimize performance,<br />
                                    reduce costs, and ensure business continuity for enterprises worldwide.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row align-items-start">
                        {/* Left Side - Services Menu */}
                        <div className="col-lg-5">
                            <div className="services-menu">
                                <div className="service-tab active" data-service="cloud-strategy">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Cloud Strategy & Consulting</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="cloud-migration">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Cloud Migration Services</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="cloud-infrastructure">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Cloud Infrastructure Management</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="devops">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">DevOps & Automation</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="cloud-security">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Cloud Security & Compliance</h3>
                                    </div>
                                </div>
                                <div className="service-tab" data-service="cloud-optimization">
                                    <div className="service-tab-content">
                                        <h3 className="service-tab-title">Cloud Cost Optimization</h3>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Right Side - Service Details */}
                        <div className="col-lg-7">
                            <div className="service-details-container">
                                {/* Cloud Strategy */}
                                <div className="service-detail active" id="cloud-strategy">
                                    <h3 className="service-detail-title">Cloud Strategy & Consulting</h3>
                                    <p className="service-detail-description">
                                        Develop a comprehensive cloud roadmap aligned with your business objectives. Our cloud consultants assess your current infrastructure, identify opportunities for cloud adoption, recommend optimal cloud platforms (AWS, Azure, GCP), and design multi-cloud or hybrid cloud strategies. We ensure your cloud journey maximizes ROI while minimizing risks and disruption.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Cloud Consultation</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Cloud Migration */}
                                <div className="service-detail" id="cloud-migration">
                                    <h3 className="service-detail-title">Cloud Migration Services</h3>
                                    <p className="service-detail-description">
                                        Seamlessly migrate your applications, data, and workloads to the cloud with minimal downtime. We employ proven migration strategies including lift-and-shift, re-platforming, and re-architecting. Our phased approach ensures data integrity, application performance, and business continuity throughout the migration process, with comprehensive testing and rollback plans.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Migration Assessment</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Cloud Infrastructure */}
                                <div className="service-detail" id="cloud-infrastructure">
                                    <h3 className="service-detail-title">Cloud Infrastructure Management</h3>
                                    <p className="service-detail-description">
                                        Deploy and manage scalable, reliable cloud infrastructure tailored to your needs. Our team designs cloud architectures leveraging virtual machines, containers, serverless computing, load balancers, and auto-scaling. We implement infrastructure-as-code (IaC) using Terraform and CloudFormation, ensuring consistent, reproducible, and manageable cloud environments.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Infrastructure Services</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* DevOps & Automation */}
                                <div className="service-detail" id="devops">
                                    <h3 className="service-detail-title">DevOps & Automation</h3>
                                    <p className="service-detail-description">
                                        Accelerate software delivery with DevOps practices and CI/CD pipelines. We implement automated workflows using Jenkins, GitLab CI, GitHub Actions, and Azure DevOps. Our DevOps solutions include containerization with Docker and Kubernetes, continuous monitoring, automated testing, and deployment automation that reduce time-to-market and improve software quality.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request DevOps Implementation</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Cloud Security */}
                                <div className="service-detail" id="cloud-security">
                                    <h3 className="service-detail-title">Cloud Security & Compliance</h3>
                                    <p className="service-detail-description">
                                        Protect your cloud assets with enterprise-grade security measures. We implement identity and access management (IAM), encryption at rest and in transit, network security groups, DDoS protection, and security monitoring. Our compliance experts ensure adherence to HIPAA, GDPR, PCI-DSS, SOC 2, and industry-specific regulations through comprehensive security frameworks.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Security Assessment</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>

                                {/* Cloud Optimization */}
                                <div className="service-detail" id="cloud-optimization">
                                    <h3 className="service-detail-title">Cloud Cost Optimization</h3>
                                    <p className="service-detail-description">
                                        Maximize cloud ROI by optimizing resource utilization and reducing unnecessary expenses. We analyze usage patterns, identify cost-saving opportunities, implement reserved instances and savings plans, eliminate waste, and establish FinOps practices. Our continuous optimization approach typically reduces cloud costs by 30-50% while maintaining or improving performance.
                                    </p>
                                    <button className="service-detail-btn">
                                        <span>Request Cost Analysis</span>
                                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                            <path d="M4.16669 10H15.8334M15.8334 10L10 4.16669M15.8334 10L10 15.8334"
                                                stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Cloud Technologies Section */}
            <section className="ai-capabilities-section">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="section-header text-center mb-5">
                                <span className="section-tagline-white">CLOUD PLATFORMS & TECHNOLOGIES</span>
                                <h2 className="section-title-dark">Cloud Technologies & Services We Master</h2>
                                <p className="section-description-dark">
                                    CLOUD MIND X leverages leading cloud platforms and cutting-edge technologies to deliver robust, scalable, and innovative cloud solutions. Our expertise spans across <strong>AWS, Azure, Google Cloud, and hybrid cloud environments</strong>, serving diverse industries including healthcare, finance, retail, manufacturing, education, and technology sectors worldwide.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        {/* AWS Services */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M24 8L36 14V22C36 29 30 35 24 40C18 35 12 29 12 22V14L24 8Z" stroke="#4187f7" strokeWidth="2" strokeLinejoin="round" />
                                        <path d="M24 18V28M20 24H28" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Amazon Web Services (AWS)</h4>
                                <p className="capability-description">
                                    Deploy comprehensive solutions using AWS's extensive service portfolio including EC2, S3, Lambda, RDS, ECS, EKS, and more. Our AWS-certified architects design fault-tolerant, highly available systems leveraging AWS's global infrastructure, enabling businesses to scale seamlessly and innovate rapidly with world-class cloud services.
                                </p>
                            </div>
                        </div>

                        {/* Microsoft Azure */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="10" y="10" width="28" height="28" rx="4" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M18 18L30 30M30 18L18 30" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" />
                                        <circle cx="24" cy="24" r="6" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Microsoft Azure</h4>
                                <p className="capability-description">
                                    Implement enterprise-grade solutions with Azure's comprehensive cloud platform including Azure VMs, App Services, Azure Functions, Cosmos DB, AKS, and Azure AI. Our Azure expertise enables seamless integration with Microsoft ecosystem, hybrid cloud deployments, and enterprise applications tailored for modern business requirements.
                                </p>
                            </div>
                        </div>

                        {/* Google Cloud Platform */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="24" cy="24" r="14" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M24 10V24L34 28" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <circle cx="24" cy="24" r="4" fill="#4187f7" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Google Cloud Platform (GCP)</h4>
                                <p className="capability-description">
                                    Leverage Google's innovative cloud infrastructure with Compute Engine, Cloud Storage, Cloud Functions, BigQuery, GKE, and powerful AI/ML services. Our GCP solutions deliver exceptional performance, advanced analytics capabilities, and seamless integration with Google's cutting-edge technologies for data-driven businesses.
                                </p>
                            </div>
                        </div>

                        {/* Hybrid & Multi-Cloud */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M14 20C10 20 8 23 8 26C8 29 10 32 14 32H34C37 32 40 29 40 26C40 23 38 20 34 20C34 16 31 12 26 12C21 12 18 15 18 19C16 19 14 20 14 20Z" stroke="#4187f7" strokeWidth="2" strokeLinejoin="round" />
                                        <path d="M24 19V28M24 19L20 23M24 19L28 23" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Hybrid & Multi-Cloud Solutions</h4>
                                <p className="capability-description">
                                    Design flexible cloud architectures spanning multiple cloud providers and on-premises infrastructure. Our hybrid and multi-cloud strategies prevent vendor lock-in, optimize costs, ensure business continuity, and enable workload portability while maintaining unified management, security, and compliance across environments.
                                </p>
                            </div>
                        </div>

                        {/* Container Orchestration */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="8" y="12" width="12" height="12" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="28" y="12" width="12" height="12" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="8" y="28" width="12" height="12" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="28" y="28" width="12" height="12" rx="2" stroke="#4187f7" strokeWidth="2" />
                                        <circle cx="24" cy="24" r="4" fill="#4187f7" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Container Orchestration</h4>
                                <p className="capability-description">
                                    Modernize applications with containerization using Docker and Kubernetes orchestration. We implement container strategies for microservices architectures, enabling rapid deployment, efficient resource utilization, seamless scaling, and simplified application management across development, testing, and production environments.
                                </p>
                            </div>
                        </div>

                        {/* Serverless Computing */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 16L24 10L36 16M12 24L24 18L36 24M12 32L24 26L36 32" stroke="#4187f7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        <circle cx="24" cy="24" r="3" fill="#4187f7" opacity="0.3" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Serverless Computing</h4>
                                <p className="capability-description">
                                    Build event-driven applications with serverless architectures using AWS Lambda, Azure Functions, and Google Cloud Functions. Eliminate infrastructure management, pay only for actual usage, achieve automatic scaling, and accelerate development while reducing operational overhead and focusing on business logic.
                                </p>
                            </div>
                        </div>

                        {/* Cloud Databases */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <ellipse cx="24" cy="16" rx="14" ry="6" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M10 16V26C10 28.2 14 32 24 32C34 32 38 28.2 38 26V16" stroke="#4187f7" strokeWidth="2" />
                                        <path d="M10 26V36C10 38.2 14 42 24 42C34 42 38 38.2 38 36V26" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Cloud Database Solutions</h4>
                                <p className="capability-description">
                                    Deploy managed database services including Amazon RDS, Aurora, DynamoDB, Azure SQL Database, Cosmos DB, and Cloud Firestore. Our database solutions ensure high availability, automatic backups, point-in-time recovery, read replicas, and optimal performance for relational, NoSQL, and time-series data requirements.
                                </p>
                            </div>
                        </div>

                        {/* Cloud Monitoring & Analytics */}
                        <div className="col-lg-6 col-md-6 mt-3">
                            <div className="capability-card">
                                <div className="capability-icon">
                                    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <rect x="8" y="28" width="6" height="12" rx="1" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="17" y="20" width="6" height="20" rx="1" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="26" y="14" width="6" height="26" rx="1" stroke="#4187f7" strokeWidth="2" />
                                        <rect x="35" y="22" width="6" height="18" rx="1" stroke="#4187f7" strokeWidth="2" />
                                    </svg>
                                </div>
                                <h4 className="capability-title">Cloud Monitoring & Analytics</h4>
                                <p className="capability-description">
                                    Implement comprehensive monitoring and analytics solutions using CloudWatch, Azure Monitor, Google Cloud Operations, and third-party tools like Datadog and New Relic. Gain real-time visibility into application performance, infrastructure health, user behavior, and business metrics with intelligent alerting and automated remediation.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CloudServices
